import { alpha } from "@mui/material/styles";

export default function ListItemButton(theme) {
	return {
		MuiListItemButton: {
			styleOverrides: {
				root: {
					fontSize: 16,
					fontFamily: "'General Sans', sans-serif",
					fontWeight: 500,
					lineHeight: "1.5",
					padding: "8px 12px",
					backgroundColor: "transparent",
					color: theme.palette.secondary.main,
					textTransform: "capitalize",
					"&:hover": {
						backgroundColor: "transparent",
						color: theme.palette.primary.main,
					},
					"&.Mui-selected": {
						backgroundColor: "transparent",
						color: theme.palette.primary.main,
						"&:hover": {
							backgroundColor: "transparent",
							color: theme.palette.primary.main,
						},
					},
					".MuiListItemIcon-root": {
						color: "currentColor",
						minWidth: 34,
					},
					".MuiTypography-body1": {
						fontSize: 16,
						fontFamily: "'General Sans', sans-serif",
						fontWeight: 500,
						lineHeight: "1.5",
					},
					"+.MuiCollapse-root": {
						".MuiButtonBase-root": {
							letterSpacing: 0.17,
							fontWeight: "400",
							paddingLeft: 47,
							lineHeight: 1.43,
							".MuiTypography-body1": {
								letterSpacing: 0.17,
								fontWeight: 400,
								lineHeight: 1.43,
							},
							"&.Mui-selected": {
								backgroundColor: alpha(
									theme.palette.primary.main,
									0.1
								),
								borderRadius: 6,
							},
							"&:hover": {
								backgroundColor: alpha(
									theme.palette.primary.main,
									0.1
								),
								borderRadius: 6,
							},
						},
					},
				},
			},
		},
	};
}
